import styles from '../Help.module.scss';

interface IHowToStep {
  stepNumber: number;
  content: React.ReactNode;
  listContent?: string[];
  imgSrc?: string;
}

const HowToStep = (props: IHowToStep) => {
  return (
    <>
      <div className='mt-4'>
        <h3>Step {props.stepNumber}</h3>
        <p>{props.content}</p>
        {props.listContent && (
          <ul>
            {props.listContent.map((a, idx) => {
              return <li key={idx}>{a}</li>;
            })}
          </ul>
        )}
        {props.imgSrc && (
          <div className='text-center'>
            <img
              className={`img-fluid ${styles.howToImg}`}
              src={props.imgSrc}
              alt={`Step ${props.stepNumber}`}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default HowToStep;
